export default "__VITE_ASSET__2KvOxDLL__"